import { Venue } from "./schema";

export const getVenueHasMobileOrdering = (venue: Venue): boolean => {
  return (
    venue.enabledFeatures.tablePay || venue.enabledFeatures.onlineSimpleOrdering
  );
};

export const getVenueHasTablePay = (venue: Venue): boolean => {
  return venue.enabledFeatures.tablePay;
};
export const getVenueHasTablePayOrdering = (venue: Venue): boolean => {
  return venue.enabledFeatures.tablePayOrdering;
};

export const getVenueHasTableService = (venue: Venue): boolean => {
  return venue.enabledFeatures.tableServiceEnabled;
};

export const getVenueHasSimpleOrdering = (venue: Venue): boolean => {
  return venue.enabledFeatures.onlineSimpleOrdering;
};
